export default __webpack_public_path__ + "js/stellarium-web-engine.06229ae9.wasm";